import {
  Title,
  Group,
  Text,
  Box
} from '@mantine/core';
import { IconCalendar } from '@tabler/icons-react';
import { formatDate } from '../utils/dateUtils';

const CardButton = ({title, content, action, endDate}) => {

  return(
    <div className="row">
      <div className="card-base fill-animation" onClick={action} style={{cursor:action?'pointer':'default'}}>
        <Group justify="space-between" align="flex-start" mb={'lg'} wrap="nowrap">
          <Title order={2} fw={400} style={{flex: 1}}>
            {title}
          </Title>
          {endDate && (
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '6px 14px',
                borderRadius: '8px',
                backgroundColor: 'rgba(231, 33, 102, 0.1)',
                border: '1.5px solid #e72166',
                flexShrink: 0,
                marginLeft: '12px'
              }}
            >
              <IconCalendar size={16} color="#e72166" />
              <Text 
                size="sm" 
                fw={600} 
                c="#e72166"
                style={{ whiteSpace: 'nowrap' }}
              >
                Cierre: {formatDate(endDate)}
              </Text>
            </Box>
          )}
        </Group>
        <div>
          {content}
        </div>
      </div>
    </div>
  )
}

export default CardButton;